import React, { useState, useEffect } from "react";
import { Grid, Typography, TextField, Autocomplete } from "@material-ui/core";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { makeStyles } from "@material-ui/styles";
import { dashboardStyle } from "../InvoiceDetails/style.js";
import { formatDateTimeForBackend } from "../../../../Functions.js";
import isOldDateValidate from "../../../../Functions/isOldDateValidate.js";
import Heading from "../../../../StyledComponents/Heading/Heading.js";
import getParameterByName from "../../../../Functions/functions.js";
import paymentTermTooltips from "./constants.js";
import moment from "moment";


const useStyles = makeStyles(dashboardStyle);

const Stylecolor = {
  color: "black",
  fonStyle:"bold"
};
const spanStyle = {
    color:"#999" ,fontSize:"14px"
  
  }

const PaymentDetailsTextField = ({
  formState,
  setFormState,
  multipleData,
  disabled,
  setOpenInvalidWarningDate,
  alignForAttachment
}) => {
  const edit = getParameterByName("edit");
  const classes = useStyles();
  const changeHandler = (e) => {
    const { name, value } = e.target;
    setFormState((formState) => ({
      ...formState,
      [name]: value,
    }));
  };

  const autocompleteChangeHandler = (name, value) => {
    setFormState((formState) => ({
      ...formState,
      invoice_Payment: {
        ...formState?.invoice_Payment,
        [name]: value,
      },
    }));
  };
  return (
    <div style={{ margin: "20px 0px" }}>
      <Heading title="Payment" />
      <Grid container  direction={'row'} spacing={3} style={{ marginTop: "3px" }}>
        <Grid
          item
          xs={12}
          sm={6}
          md={alignForAttachment ? 6 : 3}
          lg={alignForAttachment ? 6 : 3}
          style={{ paddingLeft: "28px" }}
        >
          <Typography variant="h5" style={Stylecolor}>Baseline Date:{` `}
          <span style={spanStyle}>
          {moment().format("YYYY-MM-DD")}
            </span>
          </Typography>
        
          {/*
            <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              value={formState?.invoice_Date || ""}
              onChange={(newValue) => {
                autocompleteChangeHandler("baseLine", newValue);
              }}
              name=""
              error={false}
              // disabled={disabled}
              disabled={true}
              renderInput={(params) => (
                <TextField
                  fullWidth
                  size="small"
                  id="outlined-basic"
                  label="Outlined"
                  variant="outlined"
                  {...params}
                  error={false}
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                />
              )}
            />
                </LocalizationProvider>*/}
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={alignForAttachment ? 6 : 3}
            lg={alignForAttachment ? 6 : 3}
          style={{ paddingRight: "18px" }}
        >
          <Typography variant="h5" style={Stylecolor}>
           Due Date:{` `}   
          <span style={spanStyle}>
          { formState?.invoice_Payment?.dueOn ||
            formState?.invoice_Payment?.DueOn}
            </span>
          </Typography>
         
          {/* <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              value={
                formState?.invoice_Payment?.dueOn ||
                formState?.invoice_Payment?.DueOn ||
                ""
              }
              onChange={(newValue) => {
                isOldDateValidate(formatDateTimeForBackend(newValue),
                    setOpenInvalidWarningDate,)
                autocompleteChangeHandler("dueOn", formatDateTimeForBackend(newValue));
              }}
              error={false}
              disabled={disabled}
              renderInput={(params) => (
                <TextField
                  fullWidth
                  size="small"
                  id="outlined-basic"
                  name="dueOn"
                  variant="outlined"
                  disabled={disabled}
                  {...params}
                  error={false}
                  sx={{
                    "& legend": { display: "none" },
                    "& fieldset": { top: 0 },
                  }}
                  required
                  onChange={(e) => {
                autocompleteChangeHandler("dueOn", formatDateTimeForBackend(e.target.value));
              }}
                />
              )}
            />
            </LocalizationProvider>*/}
        </Grid>
        {/* Payment Method */}
        <Grid item xs={12} sm={6}
        md={alignForAttachment ? 6 : 3}
        lg={alignForAttachment ? 6 : 3}
         >
          <Typography  variant="h5" style={Stylecolor}>
          Payment Method:{` `}
          <span style={spanStyle}>
          {formState?.invoice_Payment?.paymentMethod ||
            formState?.invoice_Payment?.PaymentMethod}
            </span>
          </Typography>
        
        </Grid>
        {/* Payment Terms */}
        <Grid item xs={12} sm={6} 
        md={alignForAttachment ? 6 : 3}
            lg={alignForAttachment ? 6 : 3}
        >
          <Typography variant="h5" style={Stylecolor}>
          Payment Terms:{` `}
          <span style={spanStyle}>
          {formState?.invoice_Payment?.paymentTerms || ""}
            </span>
          </Typography>
          {/* <TextField
            fullWidth
            name="paymentTerms"
            size="small"
            type="text"
            value={formState?.invoice_Payment?.paymentTerms}
            id="outlined-basic"
            variant="outlined"
            onChange={(event) => {
              autocompleteChangeHandler("paymentTerms", event.target.value);
            }}
            disabled
            sx={{
              "& legend": { display: "none" },
              "& fieldset": { top: 0 },
            }}
          /> */}
        
        </Grid>
        {/* Payment Method Supp */}
        <Grid item xs={12} sm={6}
        md={alignForAttachment ? 6 : 3}
            lg={alignForAttachment ? 6 : 3}
         >
          <Typography variant="h5" style={Stylecolor}>
          Payment Method Supp:{` `}
          <span style={spanStyle}>
          {  formState?.invoice_Payment?.paymentMethSupp ||
            formState?.invoice_Payment?.paymentMethSupp}
            </span>
          </Typography>
        
        </Grid>
      </Grid>
    </div>
  );
};

export default PaymentDetailsTextField;
